module.exports = {"620921100":"中东镇","620921101":"鼎新镇","620921102":"金塔镇","620921103":"东坝镇","620921105":"航天镇","620921106":"大庄子镇","620921107":"西坝镇","620921204":"古城乡","620921209":"羊井子湾乡","620921400":"甘肃亚盛农工商集团有限责任公司","620921401":"工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620921.json
// module id = 2933
// module chunks = 0